import { Injectable } from '@angular/core';

const maxItemsInCache: number = 1000;

@Injectable({ providedIn: 'root' })
export class MemoryCacheService {
  cache: Map<string, any>;
  constructor() {
    this.cache = new Map();
  }

  getItem(key: string): any {
    if (!this.cache.has(key)) {
      return undefined;
    }
    const payload = this.cache.get(key);
    if (payload.expiration < new Date()) {
      this.cache.delete(key);
      return undefined;
    }
    return payload.data;
  }

  setItem(key: string, data: any, expirationSeconds?: number): void {
    const date = new Date();
    date.setSeconds(date.getSeconds() + (expirationSeconds || 30));
    const payload = {
      expiration: date,
      data: data
    };

    if (this.cache.size >= maxItemsInCache) {
      this.cache.delete(this.cache.keys[0]);
    }

    this.cache.set(key, payload);
  }

  deleteItem(key: string): void {
    this.cache.delete(key);
  }
}
